import axios from 'axios';
import React, { useRef }  from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import './AdSliderLaptop.css';
import icondelete from './img/icons/icons8-remove-100.png';
import iconadd from './img/icons/icons8-add-new-100.png';
import iconback from './img/icons/left-chevron.png';

function AdSliderLaptop(){
  const [slidePcImg, setSlidePcImg] = useState([])
  const [active, setActive] = useState(true);
  const [resp, setResp] = useState("");
  const [fileName, setFileName] = useState("Slide");
  const file = useRef();

  const uploader = async () => {

    setFileName('Slide');

    if(file.current.files.length === 0){
      setResp('Please choose an image');
    }else{

      const formData = new FormData();
      console.log(file);
      formData.append("picture", file.current.files[0]);
      formData.append("name", fileName);

      var xhr = new XMLHttpRequest();

      xhr.open('POST', 'https://toycityzimbabwe.com/backend/uploadSlidePc.php', true);

      xhr.onload = function(){
        setResp(this.responseText);

        setActive(!active);
        document.getElementById("appearaddpc").style.display = "none";

        axios
            .get('https://toycityzimbabwe.com/backend/getPcSlider.php')
            .then(res => {
              setSlidePcImg(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      }

      xhr.send(formData);
    }
  };

  useEffect(() => {
    axios
    .get('https://toycityzimbabwe.com/backend/getPcSlider.php')
    .then(res => {
      setSlidePcImg(res.data)
    })
    .catch( error => {
        console.log(error)
    });
    
  }, [])

  const hadd = () => {
    setActive(!active);

    if(!active)
      document.getElementById("appearaddpc").style.display = "none";
    else
      document.getElementById("appearaddpc").style.display = "block";
  }

  const hdelete = (id) => {

    axios
        .get("https://toycityzimbabwe.com/backend/deletePcSlide.php", {params: { id }})
        .then(data => {
          console.log(data.data)
        })
        .catch(error => console.log(error));

    
    axios
        .get('https://toycityzimbabwe.com/backend/getPcSlider.php')
        .then(res => {
          setSlidePcImg(res.data)
        })
        .catch( error => {
            console.log(error)
        });
    
  }
  return (
    <div className='adsliderlaptop'>
      <h1>Slider Laptop</h1>
      <button onClick={hadd}>
        {active ? <img src={iconadd} alt='iconadd' />
          : <img src={iconback} alt='iconadd' />
        }
      </button>
      <div id='appearaddpc' className='adsliderlaptop__upload'>
        <input type="file"  accept="image/*" ref={file} />
        <button onClick={uploader}>Upload</button>
      </div>
      <div className='adsliderlaptop__sms'>
        {resp}
      </div>
      <div className='adsliderlaptop__sliders'>
        {slidePcImg.map((obj) => (
          <div className='adsliderlaptop__slider'>
            <img src={obj.img} alt='slidePcImg'/>
            <div>
              <button onClick={() => hdelete(obj.slide_id)} > <img src={icondelete} alt='icondelete' /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AdSliderLaptop;